import createReducer from '../../utils/createReducer';
import * as actionTypes from '../actions/actionTypes';
const TWITTER_MAX_TEXT_LEN = 140;
const instagramId = 2;
const twitterId = 4;

const initialState = {
  requesting: false,
  error: null,

  currentStep: 0,
  completedStep: 0,

  campaignName: '',
  integrations: [],
  textBody: '',
  files: [],
  currentCustomsId: 0,
  customs: [],
  socialPageId: 0,
  scheduleDate: null,
  timeZone: null,
};

const wizard = createReducer(initialState, {
  // ui
  [actionTypes.CAMPAIGN_SET_NAME_UPDATE](state, { name }) {
    return { ...state, campaignName: name };
  },
  [actionTypes.WIZARD_SET_TEXT_BODY_UPDATE](state, { payload }) {
    return { ...state, textBody: payload };
  },
  [actionTypes.WIZARD_SET_FILES](state, { payload }) {
    return { ...state, files: payload };
  },
  [actionTypes.WIZARD_APPEND_FILES](state, { payload }) {
    return { ...state, files: [...state.files, ...payload] };
  },
  [actionTypes.WIZARD_REMOVE_FILE](state, { payload }) {
    return { ...state, files: [...state.files.filter((x) => x !== payload)] };
  },
  [actionTypes.CAMPAIGN_ENABLE_INTEGRATION_UPDATE](state, { payload }) {
    return {
      ...state,
      integrations: payload,
    };
  },
  [actionTypes.STEPS_SET_CURRENT_STEP](state, { payload }) {
    return { ...state, currentStep: payload };
  },
  [actionTypes.STEPS_SET_COMPLETED_STEP](state, { payload }) {
    return { ...state, completedStep: payload };
  },
  // customs
  [actionTypes.WIZARD_UPDATE_ACTIVE_CUSTOMS](state, { payload }) {
    return { ...state, currentCustomsId: payload };
  },
  // schedule date
  [actionTypes.WIZARD_STORE_SCHEDULE_DATE](state, { payload }) {
    return { ...state, scheduleDate: payload };
  },
  // time zone
  [actionTypes.WIZARD_STORE_TIMEZONE](state, { payload }) {
    return { ...state, timeZone: payload };
  },
  // add files
  [actionTypes.WIZARD_ADD_CUSTOMS_FILES](state, { payload }) {
    const { id, files } = payload;
    let isValid = true;

    let myCustoms = [...state.customs];

    let desiredCustoms = myCustoms.find((x) => x.id === id) || null;

    if (desiredCustoms) {
      desiredCustoms.files = [...desiredCustoms.files, ...files];
    }

    if (desiredCustoms.id === 2) {
      // проверка на Инстаграмм
      isValid = desiredCustoms.files.length !== 1 ? false : true;
    }
    desiredCustoms.isValid = isValid;

    return { ...state, customs: myCustoms };
  },
  // remove file
  [actionTypes.WIZARD_REMOVE_CUSTOMS_FILE](state, { payload }) {
    const { id, file } = payload;
    let isValid = true;

    let myCustoms = [...state.customs];

    let desiredCustoms = myCustoms.find((x) => x.id === id) || null;

    if (desiredCustoms) {
      desiredCustoms.files = desiredCustoms.files.filter((x) => x !== file);
    }

    if (desiredCustoms.id === instagramId) {
      // проверка на Инстаграмм
      isValid = desiredCustoms.files.length !== 1 ? false : true;
    }
    desiredCustoms.isValid = isValid;

    return { ...state, customs: myCustoms };
  },
  [actionTypes.WIZARD_SET_CUSTOMS_TEXT](state, { payload }) {
    const { id, textBody } = payload;
    let isValid = true;

    if (id === twitterId) {
      //проверка на Твиттер
      isValid = textBody.length > TWITTER_MAX_TEXT_LEN ? false : true;
    }

    let myCustoms = [...state.customs];

    let desiredCustoms = myCustoms.find((x) => x.id === id) || null;

    if (desiredCustoms) {
      desiredCustoms.textBody = textBody;
    }

    desiredCustoms.isValid = isValid;

    return { ...state, customs: myCustoms };
  },
  // social page id
  [actionTypes.WIZARD_SET_CUSTOMS_SOCIAL_PAGE](state, { payload }) {
    const { id, socialPageId } = payload;
    let isValid = true;

    let myCustoms = [...state.customs];

    let desiredCustoms = myCustoms.find((x) => x.id === id) || null;

    if (desiredCustoms) {
      desiredCustoms.socialPageId = socialPageId;
      if (desiredCustoms.id === twitterId) {
        //проверка на Твиттер
        isValid = desiredCustoms.textBody.length > TWITTER_MAX_TEXT_LEN ? false : true;
      } else if (desiredCustoms.id === instagramId) {
        // проверка на Инстаграмм
        isValid = desiredCustoms.files.length !== 1 ? false : true;
      }
      desiredCustoms.isValid = isValid;
    }

    return { ...state, customs: myCustoms };
  },
  // store customs array
  [actionTypes.WIZARD_STORE_CUSTOMS](state, { payload }) {
    return { ...state, customs: [...state.customs, ...payload] };
  },
  [actionTypes.WIZARD_SET_STORE_CUSTOMS](state, { payload }) {
    return { ...state, customs: payload };
  },
  // reset state
  [actionTypes.WIZARD_RESET_STATE]() {
    return initialState;
  },
});

export default wizard;

export const getIsRequesting = (state) => state.wizard.requesting;
export const getError = (state) => state.wizard.error;

export const getCampaignName = (state) => state.wizard.campaignName;
export const getIntegrations = (state) => state.wizard.integrations;
export const getTextBody = (state) => state.wizard.textBody;
export const getFiles = (state) => state.wizard.files;
export const getCustoms = (state) => state.wizard.customs;
export const getCurrentCustomsId = (state) => state.wizard.currentCustomsId;
export const getScheduleDate = (state) => state.wizard.scheduleDate;
export const getTimeZone = (state) => state.wizard.timeZone;

export const getCurrentStep = (state) => state.wizard.currentStep;
export const getCompletedStep = (state) => state.wizard.completedStep;
